import React, { useState, useRef, useEffect } from 'react';
import Dialog from '../../../components/Dialog';
import { IconCopy } from '../../../components/dialogIcons';

/*
  The same item, somewhere else in the same building.

  Ported onto the shared dialog shell on 5 September 2026, to Group E's approved
  drawing `dialog-already-counted-*.png`.

  **It is a question, not a warning**, which the old wording missed: an item
  showing up twice is ordinary in a building with a stock room and a treatment
  room, and the answer is a second line rather than a correction. Naming where
  this one is keeps both counts.
*/
export default function DupeLocationModal({ existingItem, countedByName, onAddLocation, onCancel }) {
  const [location, setLocation] = useState('');
  const inputRef = useRef(null);
  useEffect(() => { if (inputRef.current) inputRef.current.focus(); }, []);

  const ready = location.trim().length > 0;
  function confirm() {
    if (!ready) return;
    onAddLocation(location.trim().toUpperCase());
  }

  return (
    <Dialog
      kind="question" icon={<IconCopy />}
      title="This item is already counted"
      record={[existingItem.item_number_raw, existingItem.description_raw].filter(Boolean).join(' - ')}
      onClose={onCancel}
      footer={
        <>
          <button className="btn btn-quiet" onClick={onCancel}>Cancel</button>
          <button className="btn btn-primary" onClick={confirm} disabled={!ready}>Add a second line</button>
        </>
      }
    >
      <div style={{ background: 'var(--warning-bg)', borderRadius: 12, padding: '12px 14px', fontSize: 13, color: 'var(--warning-ink)', lineHeight: 1.55 }}>
        <strong>{existingItem.item_number_raw}</strong> is already on this sheet:
        {existingItem.quantity === null || existingItem.quantity === undefined
          ? ' not counted yet'
          : ' ' + existingItem.quantity + ' counted'}
        {countedByName ? ' by ' + countedByName : ''}
        {existingItem.location ? ', at ' + existingItem.location + '.' : ', with no Item Location recorded.'}
      </div>
      <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6, margin: '14px 0 0' }}>
        If the same item also sits somewhere else in the building, name that place and it gets a second
        line of its own rather than overwriting the first.
      </p>
      <div className="form-lbl">Where this one is</div>
      <input ref={inputRef} className="form-inp" placeholder="e.g. SHELF B, BACK ROOM, AISLE 3"
        value={location} onChange={e => setLocation(e.target.value.toUpperCase())}
        onKeyDown={e => { if (e.key === 'Enter') confirm(); }} />
    </Dialog>
  );
}
